import { Button, List } from "antd";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Service from "../../Classes/Service";
import { pickAFileSliceDispatch, serviceModalSliceDispatch, serviceViewerSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import ServiceModal from ".././ServiceModal/ServiceModal";

const ServiceViewer = () => {
    const currentServices = useSelector((state: any) => state.pickAFile.serviceList);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);

    const addModal = useSelector((state: any) => state.serviceViewer.addModal);
    const editModal = useSelector((state: any) => state.serviceViewer.editModal);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    function DeleteAService(idToDelete, updateState: boolean = true) {

        let filteredServices = currentServices.filter(service => service.serviceId != parseInt(idToDelete) ||
            service.serviceId != idToDelete);
        
        let filteredServiceQuestionBrands = currentServiceQuestionBrand;
        filteredServiceQuestionBrands = filteredServiceQuestionBrands.filter(sqb => sqb.assistanceServiceId != parseInt(idToDelete))

        let filteredServiceQuestions = currentServiceQuestions;
        filteredServiceQuestions = filteredServiceQuestions.filter(sqb => sqb.assistanceServiceId != parseInt(idToDelete))

        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setServiceList, payload: filteredServices })
            //Delete any serviceQuestionBrand entries containing this brand
            dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServiceQuestionBrands })
            dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: filteredServiceQuestions })
            CreateContentsFromStates({ serviceList: filteredServices, serviceQuestions: filteredServiceQuestions, serviceBrandQuestions: filteredServiceQuestionBrands });
        }

        return filteredServices;

    }

    const HandleDelete = (event) => {
        DeleteAService(event.currentTarget.id, true)
    }

    const AddModal = (event?: any) => {
        dispatch({ type: serviceViewerSliceDispatch.setAddModal, payload: true })
        dispatch({ type: serviceViewerSliceDispatch.setEditModal, payload: false })
        dispatch({ type: serviceModalSliceDispatch.setOpen, payload: true });
    }

    const EditModal = (event?: any) => {
        dispatch({ type: serviceViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: serviceViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: serviceModalSliceDispatch.setOpen, payload: true });
    }

    const services =
        <div>
            <Button onClick={() => {
                AddModal();
                dispatch({ type: serviceModalSliceDispatch.setServiceToAdd, payload: new Service() });
                dispatch({ type: serviceViewerSliceDispatch.setCurrentService, payload: new Service() });
            }}>
                Add new Service
            </Button>
            {addModal && <ServiceModal caption={"Add new Service"} />}
            {editModal && <ServiceModal caption={"Edit"} />}
            <List
                dataSource={currentServices}
                renderItem={(currentService: any, currentServiceIndex: number) => (
                    <div>
                        <List.Item key={currentService.serviceName}>
                            <Button onClick={() => {
                                EditModal();
                                dispatch({ type: serviceModalSliceDispatch.setServiceToAdd, payload: currentService });
                                dispatch({ type: serviceViewerSliceDispatch.setCurrentService, payload: currentService });
                            }}>
                                Edit
                            </Button>
                            <Button id={currentService.serviceId} onClick={HandleDelete}>Delete</Button>
                            {currentService.serviceName}
                        </List.Item>
                    </div>
                )}
            />
        </div>
    return <div>{services}</div>
}

export default ServiceViewer;